import Breadcrumb, { type Crumb } from "./Breadcrumb";

interface Props {
  eyebrow?: string;
  title: string;
  description: string;
  image: string;
  crumbs: Crumb[];
}

export default function PageHero({ eyebrow, title, description, image, crumbs }: Props) {
  return (
    <section className="relative overflow-hidden">
      <div className="absolute inset-0">
        <img src={image} alt="" className="h-full w-full object-cover object-top" />
        <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/75 via-foreground-950/55 to-background-50" />
      </div>
      <div className="container-site relative pt-28 pb-14 md:pt-40 md:pb-20">
        <Breadcrumb items={crumbs} />
        <h1 className="font-heading text-3xl font-bold text-background-50 md:text-4xl">{title}</h1>
        {eyebrow && <span className="mt-3 inline-flex items-center gap-1.5 text-xs font-semibold uppercase tracking-wider text-accent-300"><i className="ri-sparkling-2-fill" />{eyebrow}</span>}
        <p className="mt-3 max-w-2xl text-sm leading-relaxed text-background-100/90 md:text-base">{description}</p>
      </div>
    </section>
  );
}